import React from "react";
import './Projects.css';
import project1 from '../../assets/project/project1.png'
import project2 from '../../assets/project/project2.png'
import project3 from '../../assets/project/project3.png'
import project4 from '../../assets/project/project4.png'

const projectsData = [
    {
        id: 1,
        title: "PB Staffings Business Website",
        description: "A Freelance website asked by Clients for their staffing busniess which is in 3 different locations across Canada",
        image: project1,
        technologies: ["HTML", "CSS", "Javascript", "Firebase","Agile","Bootstrap","JQuery"],
        liveDemoLink: "https://pb-staffings.web.app",
        button: "Live Demo"
    },
    {
        id: 2,
        title: "Bookdex - Android application",
        description: "Bookdex is an android app to explore, organize, and dive into your favorite reads all in one convenient platform.",
        image: project2,
        technologies: ["Android Studio", "Retrofit", "Kotlin","Firebase","Postman","REST","Unit Testing"],
        liveDemoLink: "https://play.google.com/store/apps/details?id=com.pankaj.bookdex_capstone&hl=en",
        button: "Google Play"
    },

    {
        id: 3,
        title: "Conservative Party of Canada",
        description: "Redesigned and redeveloped the campaign website for the Member of Parliament Candidate from Mississauga",
        image: project3,
        technologies: ["HTML", "CSS", "Javascript", "Firebase","Canva","Agile","Bootstrap","Photoshop"],
        liveDemoLink: "https://bijaypaudel.ca",
        button: "Live Demo"
    },

    {
        id: 4,
        title: "Transit Wind- UI/UX Design",
        description: "This is prototype built in Adobe XD, We carried Research Analysis, Wireframing, Style Guide and  User Testing",
        image: project4,
        technologies: ["User Interface Design", "User Experience", "Usability Testing", "A/B Testing", "Adobe XD"],
        liveDemoLink: "https://xd.adobe.com/view/a51d09cf-3bd7-4af8-9191-16dcddd90576-f04e/?fullscreen",
        button: "Live Demo"
    },

];

function Projects() {
    return (
        <div className="main-container" id="project">
            <div className="heading">
                <h2 className="front_">Projects;   </h2> <h2 className="back_">  I worked on !</h2>
            </div>

            <div className="projects-container">
                {projectsData.map(project => (
                    <div className="project-card" key={project.id}>
                        <img src={project.image} alt={project.title} className="project-image" />
                        <div className="project-info">
                            <h3 className="project-title">{project.title}</h3>
                            <p className="project-description">{project.description}</p>
                            <div className="technologies-used">
                                {project.technologies.map((tech, index) => (
                                    <div className="technology" key={index}>{tech}</div>
                                ))}
                            </div>
                            <a href={project.liveDemoLink} target="_blank" className="live-demo-button">{project.button}</a>
                        </div>
                    </div>
                ))}
            </div>
        </div>

    );
}

export default Projects;
